import { Suspense, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Download } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/useToast"
import { Header } from "@/layouts/header"
import { downloadSofiaFile } from "@/lib/download-file-helper"
import { AgentPlanningsTable } from "@/modules/admin/agent-plannings/components/agent-plannings-table"
import { useAgentPlanningsQueryLoader } from "@/modules/admin/agent-plannings/services/useAgentPlanningsQuery"

const AgentPlannings = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const [queryRef, loadQuery] = useAgentPlanningsQueryLoader()
  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    loadQuery({}, { fetchPolicy: "network-only" })
  }, [loadQuery])

  const handleExportExcel = async () => {
    setIsDownloading(true)
    await downloadSofiaFile({
      endpoint: "api/export/agent-plannings",
      fileName: "agent-plannings.xlsx",
      onComplete: () => toast({ description: t("admin.agentPlannings.export.success") }),
      onError: () => toast({ description: t("admin.agentPlannings.export.error") }),
    })
    setIsDownloading(false)
  }

  return (
    <>
      <Header title={t("admin.agentPlannings.pageTitle")}>
        <Button className="p-4" isLoading={isDownloading} disabled={isDownloading} onClick={handleExportExcel}>
          <Download size={24} />
          {t("admin.agentPlannings.export.label")}
        </Button>
      </Header>
      <div className="grid-cols-1fr-auto bg-background-subdued grid grid-rows-1 pt-8">
        {queryRef && (
          <Suspense fallback={null}>
            <AgentPlanningsTable queryRef={queryRef} />
          </Suspense>
        )}
      </div>
    </>
  )
}

export { AgentPlannings }
